import z from 'zod';
import { InventoryGroupSummarySchema } from './InventoryGroupSummary';

export const InventoryGroupListResultSchema = z.object({
    data: z.array(InventoryGroupSummarySchema),
    total: z.number(),
});

export type InventoryGroupListResult = z.infer<typeof InventoryGroupListResultSchema>;
